import React from 'react';
import { Item } from '../common';

import { MenuWrapper, Menu } from './Items.styles';
import { AccountMenu, AccountMenuProps } from './AccountMenu';
import { NavMenu, NavMenuProps } from './NavMenu';
import { useTranslations } from '@lang';

export type ItemsProps = AccountMenuProps & NavMenuProps;

export const Items: React.FC<ItemsProps> = ({
  isLoggedIn,
  isRoomsIntegrated,
  isTablesIntegrated,
  isRetailEnabled,
  isSpaTreatmentEnabled,
  isFacilitiesEnabled,
  isSpaClassesEnabled,
  isSpaDaysEnabled,
  websiteUrl,
}) => {
  const { t } = useTranslations();
  return (
    <MenuWrapper>
      <Menu>
        <NavMenu
          isTablesIntegrated={isTablesIntegrated}
          isRoomsIntegrated={isRoomsIntegrated}
          isRetailEnabled={isRetailEnabled}
          isSpaTreatmentEnabled={isSpaTreatmentEnabled}
          isFacilitiesEnabled={isFacilitiesEnabled}
          isSpaClassesEnabled={isSpaClassesEnabled}
          isSpaDaysEnabled={isSpaDaysEnabled}
        />
        <AccountMenu isLoggedIn={isLoggedIn} />
        <Item route={websiteUrl} message={t('menu.backToMainWebsite')} externalLink />
      </Menu>
    </MenuWrapper>
  );
};
